import { SetStateAction } from "react";
import { toPrice } from "./toPrice";

export const quickNumberInput = (
  value: SetStateAction<string>,
  prevValue: string,
) => {
  if (value.length > 0) {
    if (prevValue === "") {
      value = toPrice(Number(value) / 100) as string;
    } else {
      value = toPrice(
        Number(value.toString().replace(".", "").replace(/^0+/, "")) / 100,
      );
    }
  }
  return value;
};
